/**
 * Creates a widget that allows overlays on the 3D viewer
 * @author Alex Gryson <agr@sculpteo.com>
 * @author Antoine Orozco <aor@sculpteo.com>
 * @author Ivica Arsov <iar@sculpteo.com>
 * @copyright Sculpteo 2015
 *
 * @class
 * @param {object} design - Design to link the Viewer Overlay Widget to
 * @param {object} viewerUI - The viewer UI object
 * @^param {object} screenOptions - The initial options
 */
var ViewerOverlayWidget = function (design, viewerUI, screenOptions) {
  this.design = design;
  this.screen = null;
  this.viewerUI = viewerUI; // TEMP
  this.screens = {};
  this.screenOpts = screenOptions;
  this.updating_material = false;
};

ViewerOverlayWidget.prototype = {
  ready: function (bottom_offset, top_offset) {
    var _this = this;

    this.viewer = $("#viewer3d").Sculpteo3DViewer();
    this.setupUI(this.viewer, bottom_offset, top_offset);
    this.$container = $(".designs_main_view");

    $.Topic("printui-tab-changed").subscribe(function (tabid) {
      if (tabid == "review") {
        _this.select_screen("review");
      } else {
        _this.select_screen();
      }
    });

    $.Topic("review-mode").subscribe(function (enabled) {
      if (enabled) {
        _this.select_screen("review");
      } else {
        _this.select_screen();
      }
    });

    $.Topic("series-enter").subscribe(function () {
      _this.select_screen("series-job");
    });

    $.Topic("materials-update-start").subscribe(function (all_materials) {
      if (all_materials) {
        _this.updating_material = 2;
      } else {
        _this.updating_material = 1;
      }
    });

    $.Topic("materials-update-result").subscribe(function () {
      _this.updating_material = false;
    });

    var customViews = [];
    var customViewsMaxCount = 5;

    function addCustomViewSnapshot(t) {
      customViews.push(t);

      if (customViews.length > customViewsMaxCount) {
        $(".customViews :first-child").remove();
        customViews.shift();
      }

      var newView = $(".selectView").filter(":first").clone();

      newView.addClass("customView");
      $(newView).removeAttr("style");
      $(".selectViewPrice", newView).text("");
      $(newView).data("rotation", t);

      var url =
        _this.viewerUI.viewer.getSnapshotUrl(64, 64, 2, {
          rotq: t,
          pan: "0,0",
          zoom: "1.2",
        }) + "&nosession=1";
      var loader = new ImageLoader(url);

      loader.loadEvent = function (url, image) {
        $(newView).css("backgroundImage", "url(" + url + ")");
        loader = null;
      };

      $.when(
        _this.design.dfd_update_scale,
        _this.design.dfd_update_material
      ).then(function () {
        loader.load();
      });

      var func = function (unit_price, currency) {
        $.Topic("unit-price-updated").unsubscribe(func);
        $(newView).removeClass("load-animation");
        $(".selectViewPrice", $(newView)).text(unit_price + currency);
        $(".selectView", _this.$container).click(selectViewClick);
      };

      $.Topic("unit-price-updated").subscribe(func);
      $(".customViews").append(newView);
      $(".selectView", _this.$container).removeClass("selected");
      $(newView).addClass("selected");
      $(newView).addClass("load-animation");
      $(".selectView", _this.$container).unbind("click");
    }

    // Series-orient screen
    $.Topic("series-height-changed").subscribe(function () {
      $(".selectViewPrice").toggle(_this.design.series.enabled);

      // Update orientation viewer (for free axis)
      if (
        _this.screen == "series-orient" &&
        _this.design.series.orientation.w != _this.design.series.orientation.w
      ) {
        var animation = _this.series_orientation_animation;
        var parts = [_this.design];

        if (_this.design.partitioning) {
          parts = _this.design.partitioning.parts;
        }

        var positions = parts[0].series.positions;

        if (animation) {
          animation.cancel();
        }

        if (positions.length) {
          _this.series_orientation_animation = _this.viewer.animateCamera(
            [
              positions[0][3],
              positions[0][4],
              positions[0][5],
              positions[0][6],
            ],
            undefined,
            1.2,
            1000
          );
        } else {
          _this.series_orientation_animation = null;
        }
      }
    });

    $(".series-orient-auto-button", this.$container).on("click", function () {
      // Set auto orientation
      var axis = { w: NaN, x: NaN, y: NaN, z: NaN };

      if (
        _this.design.series.orientation.w != _this.design.series.orientation.w
      ) {
        return;
      }

      $.Topic("invalidate_price").publish();
      $.Topic("series-orientation-update").publish(axis);

      _this.design
        .update_print_op(undefined, undefined, undefined, undefined, axis)
        .then(function (data) {
          _this.viewerUI.topics["operation-updated"](data);
          $.Topic("series-orientation-changed").publish(
            _this.design.series.orientation
          );
        });
    });

    _this.ui.series_orient_cancel_button.bind("click", function () {
      // Restore saved orientation
      var axis = { w: NaN, x: NaN, y: NaN, z: NaN };

      if (
        _this.design.series.orientation.w != _this.design.series.orientation.w
      ) {
        return;
      }

      $.Topic("set-viewer-toolbar-message").publish(
        gettext("Calculating automatic orientation")
      );
      Utils.viewerProgressBar();
      $(".selectView", _this.$container).removeClass("selected");
      $.Topic("invalidate_price").publish();
      $.Topic("series-orientation-update").publish(axis);

      _this.design
        .update_print_op(undefined, undefined, undefined, undefined, axis)
        .then(function (data) {
          _this.viewerUI.topics["operation-updated"](data);
          var func = function () {
            $.Topic("series-height-changed").unsubscribe(func);
            $.Topic("set-viewer-toolbar-message").publish("");
            Utils.viewerProgressBar(0);
          };

          $.Topic("series-height-changed").subscribe(func);
          $.Topic("series-orientation-changed").publish(
            _this.design.series.orientation
          );
        });
    });

    _this.ui.series_orient_save_button.bind("click", function () {
      // Use current orientation
      var t = _this.viewer.getTransform().split(",");

      $.Topic("invalidate_price").publish();
      $.Topic("series-orientation-update").publish(t);
      _this.design
        .update_print_op(undefined, undefined, undefined, undefined, {
          w: t[0],
          x: t[1],
          y: t[2],
          z: t[3],
        })
        .then(function (data) {
          _this.viewerUI.topics["operation-updated"](data);
          $.Topic("series-orientation-changed").publish(
            _this.design.series.orientation
          );
          addCustomViewSnapshot(t.join(","));
          _this.select_screen();
        });
    });

    var viewerLocked = false;
    var turn_view = function (dir) {
      var orient = _this.viewer.getTransform();
      switch (dir) {
        case "y":
          set_view(rotateY90(orient));
          break;
        case "x":
          set_view(rotateX90_anti(orient));
          break;
        case "z":
          set_view(rotateZ90_anti(orient));
          break;
      }
    };
    // common function to set a fixed viewpoint
    var set_view = function (t, reset) {
      if (!viewerLocked) {
        viewerLocked = true;
        _this.viewer.setAutorotate(false);

        var arr = t.split(",");
        for (var i = arr.length - 1; i >= 0; i--) {
          arr[i] = parseFloat(arr[i]);
        }

        if (reset) {
          _this.viewer.resetView();
        }
        _this.viewer.animateCamera(arr, [0, 0], 1.2, 400);
        setTimeout(function () {
          viewerLocked = false;
        }, 400);
        return false;
      }
    };
    _this.ui.series_orient_buttons.find("#z-view").click(function () {
      return turn_view("z");
    });
    _this.ui.series_orient_buttons.find("#y-view").click(function () {
      return turn_view("y");
    });
    _this.ui.series_orient_buttons.find("#x-view").click(function () {
      return turn_view("x");
    });
    _this.ui.series_orient_buttons.find("#reset-view").click(function () {
      return set_view(_this.viewerUI.front_view_settings, true);
    });

    var selectOrientation = function ($el, axis) {
      if (
        axis.w == _this.design.series.orientation.w &&
        axis.x == _this.design.series.orientation.x &&
        axis.y == _this.design.series.orientation.y &&
        axis.z == _this.design.series.orientation.z
      ) {
        return;
      }

      $.Topic("set-viewer-toolbar-message").publish(
        gettext("Updating batch price")
      );
      Utils.viewerProgressBar();
      $.Topic("invalidate_price").publish();
      $.Topic("series-orientation-update").publish(axis);
      _this.ui.series_cut_slider.setValue(1.0);

      if (_this.series_orientation_animation) {
        _this.series_orientation_animation.cancel();
      }

      _this.series_orientation_animation = _this.viewer.animateCamera(
        [axis.w, axis.x, axis.y, axis.z],
        undefined,
        1.2,
        1000
      );
      _this.design
        .update_print_op(undefined, undefined, undefined, undefined, axis)
        .then(function (data) {
          var func = function (unit_price, currency) {
            $.Topic("unit-price-updated").unsubscribe(func);
            $el.removeClass("load-animation");
            $(".selectViewPrice", $el).text(unit_price + currency);
            $(".selectView", _this.$container).click(selectViewClick);
            $.Topic("set-viewer-toolbar-message").publish("");
            Utils.viewerProgressBar(0);
          };

          $.Topic("unit-price-updated").subscribe(func);
          _this.viewerUI.topics["operation-updated"](data);
          $.Topic("series-orientation-changed").publish(
            _this.design.series.orientation
          );
        });

      $(".selectView", _this.$container).removeClass("selected");
      $el.addClass("selected");
      $el.addClass("load-animation");
      $(".selectView", _this.$container).unbind("click");
    };

    var selectViewClick = function () {
      var rot = $(this).data("rotation").split(",");

      selectOrientation($(this), {
        w: rot[0],
        x: rot[1],
        y: rot[2],
        z: rot[3],
      });
    };

    $(".selectView", this.$container).click(selectViewClick);

    this.ui.series_cut_slider.setValue(1.0);
    this.ui.series_cut_slider.addEventListener(["slide", "stop"], function () {
      var min, max, margin;
      var a, b, c, d;

      margin = 0.01;
      _this.viewer.setCutColor(1.0, 0.0, 0.0, margin);

      var design = _this.design;
      var w, x, y, z;

      if (design.series.orientation.w != design.series.orientation.w) {
        var parts = [_this.design];

        if (_this.design.partitioning) {
          parts = _this.design.partitioning.parts;
        }

        var positions = parts[0].series.positions;

        if (positions.length) {
          w = positions[0][3];
          x = positions[0][4];
          y = positions[0][5];
          z = positions[0][6];
        }
      } else {
        w = design.series.orientation.w;
        x = design.series.orientation.x;
        y = design.series.orientation.y;
        z = design.series.orientation.z;
      }

      var M = Sculpteo3DViewerTransform3D.quatMat3(w, x, y, z);

      a = -M[6];
      b = -M[7];
      c = -M[8];

      var maxd = Math.max(design.size.x, design.size.y, design.size.z);
      // * 1.2 is for default zoom factor, this way slider matches initial cut height
      d =
        -(this.value - 0.5) * maxd +
        a * design.center.x +
        b * design.center.y +
        c * design.center.z;
      _this.viewer.setCutAxis(a, b, c, d);

      // Disable cuts at 1.0, as Flash viewer can't display colors at the same time
      if (this.value == 1.0) {
        _this.viewer.clrCutAxis();
      }

      // Force update to workaround Flash viewer bug
      _this.viewer.setAutorotate(false);
    });

    var check_series_may_orient = function () {
      // Check object always fits in default printer in any orientation the user could force
      var size = _this.design.size.get();
      var scale = _this.design.size.unitFactor();
      var bbox = [size.x * scale, size.y * scale, size.z * scale];
      var print_box = [
        _this.design.material.printer.max_x,
        _this.design.material.printer.max_y,
        _this.design.material.printer.max_z,
      ];

      print_box.sort(function (a, b) {
        return a - b;
      });

      var diagonal2 = bbox[0] * bbox[0] + bbox[1] * bbox[1] + bbox[2] * bbox[2];

      // Diagonal dimension of object might not fit in smallest printer tray dimension
      if (diagonal2 > print_box[0] * print_box[0]) {
        return false;
      }

      return true;
    };

    this.screens["series-job"] = {
      topics: {
        request_update_materials: function (force) {
          // Prevent interaction and hide old tray
          _this.viewer.setAutorotate(false);
          var c = _this.viewer.getBackgroundColor();

          _this.ui.disable_overlay.setBackgroundColor(c[0], c[1], c[2], 196);
          _this.ui.root.appendChild(_this.ui.disable_overlay);
          $("#print-tabs").block(null);
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Updating batch view")
          );
          Utils.viewerProgressBar();
        },

        "series-height-changed": function () {
          _this.ui.disable_overlay.detach();
          $("#print-tabs").unblock();
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);
        },
      },
      enter: function () {
        _this.viewerUI.toggle_series_view(true);

        if (_this.updating_material == 1) {
          _this.viewer.setAutorotate(false);
          var c = _this.viewer.getBackgroundColor();

          _this.ui.disable_overlay.setBackgroundColor(c[0], c[1], c[2], 196);
          _this.ui.root.appendChild(_this.ui.disable_overlay);
          $("#print-tabs").block(null);
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Updating batch view")
          );
          Utils.viewerProgressBar();
        }

        return true;
      },

      leave: function () {
        _this.viewerUI.toggle_series_view(false);
        _this.ui.disable_overlay.detach();

        return true;
      },
    };

    this.screens["series-orient"] = {
      topics: {
        "material-selected": function (design, material, finish) {
          $(
            ".selectView:not(.selected) .selectViewPrice",
            _this.$container
          ).text("");
          _this.material_changed = true;
          $(".selectView").each(function () {
            $(this).removeAttr("style");
          });
        },

        "materials-update-result": function () {
          if (_this.material_changed) {
            _this.material_changed = false;
            _this.design.series.update_orientation_thumbnails();
          }
        },
      },
      enter: function () {
        _this.ui.root.appendChild(_this.ui.series_orient_cancel_button);
        _this.ui.root.appendChild(_this.ui.series_orient_save_button);
        _this.ui.root.appendChild(_this.ui.series_cut_slider);
        $("#viewer3d > div").append(_this.ui.series_orient_buttons);
        var design = _this.design;
        var w, x, y, z;
        var ax;

        if (
          !isNaN(design.series.orientation.w) &&
          !isNaN(design.series.orientation.x) &&
          !isNaN(design.series.orientation.y) &&
          !isNaN(design.series.orientation.z)
        ) {
          w = design.series.orientation.w;
          x = design.series.orientation.x;
          y = design.series.orientation.y;
          z = design.series.orientation.z;
          ax = w + "," + x + "," + y + "," + z;
        } else if (
          (isNaN(w) || isNaN(x) || isNaN(y) || isNaN(z)) &&
          design.series.positions.length
        ) {
          w = design.series.positions[0][3];
          x = design.series.positions[0][4];
          y = design.series.positions[0][5];
          z = design.series.positions[0][6];
          ax = w + "," + x + "," + y + "," + z;
        } else {
          ax = _this.viewer.getTransform();
          w = ax.split(",")[0];
          x = ax.split(",")[1];
          y = ax.split(",")[2];
          z = ax.split(",")[3];
        }

        _this.viewer.setAutorotate(false);
        _this.viewer.animateCamera([w, x, y, z], undefined, 1.2, 0);
        $(".selectView .selectViewPrice", _this.$container).text("");
        $(".selectView .selectViewPrice", _this.$container).removeClass(
          "selected"
        );
        $(".selectView .selectViewPrice", _this.$container).toggle(
          _this.design.series.enabled
        );
        _this.design.series.update_orientation_thumbnails(); // Compute thumbnails
        var sel = false;

        $(".selectView", _this.$container).each(function () {
          if (ax == $(this).data("rotation")) {
            $(this).addClass("selected");
            $(".selectViewPrice", $(this)).text(
              $(".price-widget-quantity .unit-price .monetary-value").text() +
                $(".unit-price .currency-symbol").text()
            );
            sel = true;
          }
        });

        if (!sel) {
          addCustomViewSnapshot(ax);
          $.Topic("unit-price-updated").publish(
            $(".price-widget-quantity .unit-price .monetary-value").text(),
            $(".unit-price .currency-symbol").text()
          );
        }

        // Setup scene
        var viewer = _this.viewer;

        // Disable remote render
        viewer.setLocal(true);
        viewer.setQuality(1);

        return true;
      },

      leave: function () {
        _this.ui.series_orient_cancel_button.detach();
        _this.ui.series_orient_save_button.detach();
        _this.ui.series_cut_slider.detach();
        _this.ui.series_orient_buttons.detach();

        $(".customViews").children().remove();
        _this.viewer.clrCutAxis();
        _this.viewer.setLocal(false);
        _this.viewer.setQuality(2);

        return true;
      },
    };

    var update_hollow_scale = function (design, scale, material) {
      var dfd = true;

      if (_this.hollowingui) {
        dfd = $.Deferred();
        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Updating model")
        );
        Utils.viewerProgressBar();
        _this.hollowingui.enableUIComponents(false);
        $("#print-tabs").block(null);
        _this.hollowingui.create_holes().then(function () {
          _this.hollowingui.deinitUI();
          on_hollow_success();
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);
          $("#print-tabs").unblock();
          _this.select_screen();
          dfd.resolve();
        });
      }

      $.when(dfd).then(function () {
        if (PrintUtils.design_get_hollowing(design)) {
          $.Topic("set_mesh_warnings").publish([]);
          var opts = {
            update_scale: true,
            update_material: material,
            onModification: function (is_hollowing, msg) {
              if (is_hollowing) {
                $.Topic("set-viewer-toolbar-message").publish(
                  gettext("Hollowing your model (this could take a minute)")
                );
              } else {
                $.Topic("set-viewer-toolbar-message").publish(
                  gettext("Going back to original")
                );

                if (design.parent || design.partitioning) {
                  $.Topic("hollowing-status-update").publish(true, msg);

                  // Show the message because it will not be shown
                  // from hollowing-status-update when param is true
                  $.Topic("set_mesh_warnings").publish([msg]);
                } else {
                  $.Topic("hollowing-status-update").publish(false, msg);
                }

                $("#StaffHollowing #ModifyButton").addClass("disabled");
              }

              Utils.viewerProgressBar();
              $.Topic("invalidate_price").publish();
              $.Topic("enable-review-button").publish("hollowing", false);
              $("#print-tabs").block(null);
              $(".summary-widget").block(null);
            },
          };

          _this.hollowingui = new HollowingUI(
            _this.screenOpts["hollowing-initial"]["hollow_id"],
            _this.screenOpts["hollowing-initial"]["script_id"],
            _this.screenOpts["hollowing-initial"]["text_id"],
            _this.screenOpts["hollowing-initial"]["hollow_script"],
            _this.screenOpts["hollowing-initial"]["scale_limit"]
          );

          _this.hollowingui
            .initUI(_this.viewerUI.viewer, design, opts)
            .then(
              function (hollow_active) {
                $.Topic("invalidate_price").publish();
                var func = function () {
                  $.Topic("materials-update-result").unsubscribe(func);
                  $.Topic("materials-update-error").unsubscribe(funcerr);
                  $.Topic("update_price").publish();
                  $.Topic("update_delay").publish();
                };

                var funcerr = function () {
                  $.Topic("request_update_materials").publish(true);
                };

                $.Topic("materials-update-result").subscribe(func);
                $.Topic("materials-update-error").subscribe(funcerr);
                $.Topic("set-viewer-toolbar-message").publish("");
                Utils.viewerProgressBar(0);
                $("#print-tabs").unblock();
                $(".summary-widget").unblock();
                $.Topic("request_update_materials").publish(true);

                if (hollow_active) {
                  $.Topic("hollowing-status-update").publish(true);
                  $("#StaffHollowing #ModifyButton").removeClass("disabled");
                }
              },
              function () {
                $.Topic("set-viewer-toolbar-message").publish("");
                Utils.viewerProgressBar(0);
                $("#print-tabs").unblock();
                $(".summary-widget").unblock();
              }
            )
            .always(function () {
              _this.hollowingui = null;
              $.Topic("enable-review-button").publish("hollowing", true);
              $.Topic("optimization-operation-updated").publish(1, true);
            });
        } else if (material) {
          var parts = [design];
          var limit_scale = 0;
          var disabled = 0;

          if (design.partitioning) {
            parts = design.partitioning.parts;
          } else if (design.parent) {
            parts = design.parent.partitioning.parts;
          }

          for (var i = 0; i < parts.length; ++i) {
            if (
              !material.hole_threshold ||
              !material.wall_thickness ||
              design.order.finish == "myrtillage" ||
              design.order.finish == "chemical_smoothing"
            ) {
              disabled++;
            } else {
              if (_this.screenOpts["hollowing-initial"]["scale_limit"]) {
                var scale_limit =
                  _this.screenOpts["hollowing-initial"]["scale_limit"];
                var scaleFactor =
                  design.size.userScale * design.size.units[design.size.unit];
                var wall =
                  (material.wall_thickness * design.size.units.mm) /
                  scaleFactor;

                if (
                  wall * scale_limit > design.size.x ||
                  wall * scale_limit > design.size.y ||
                  wall * scale_limit > design.size.z
                ) {
                  limit_scale++;
                }
              }
            }
          }

          if (disabled == parts.length) {
            $.Topic("hollowing-toggle-enable").publish(
              false,
              gettext("hollowing_disabled")
            );
          } else if (limit_scale == parts.length) {
            $.Topic("hollowing-toggle-enable").publish(
              false,
              gettext("hollowing_design_too_small")
            );
          } else if (disabled + limit_scale == parts.length) {
            $.Topic("hollowing-toggle-enable").publish(
              false,
              gettext("All parts could not be hollowed")
            );
          } else if (disabled || limit_scale) {
            $.Topic("hollowing-toggle-enable").publish(
              true,
              gettext("Some parts could not be hollowed")
            );
          } else {
            $.Topic("hollowing-status-update").publish(true);
          }
        }
      });
    };

    $.Topic("scale-changed").subscribe(function (design, scale) {
      update_hollow_scale(design, scale, design.material);
    });

    $.Topic("unit-changed").subscribe(function (design, unit) {
      update_hollow_scale(design, design.size.userScale, design.material);
    });

    $.Topic("material-selected").subscribe(function (design, material, finish) {
      update_hollow_scale(design, design.size.userScale, material);
    });

    this.hollow_mat_dfd = $.Deferred();
    this.hollow_mat_dfd.resolve();

    function hollow_update_price() {
      var func = function () {
        $.Topic("materials-update-result").unsubscribe(func);
        $.Topic("materials-update-error").unsubscribe(func);
        _this.hollow_mat_dfd.resolve();
      };

      $.Topic("invalidate_price").publish();
      $.Topic("request_update_materials").publish(true);

      if (_this.hollow_mat_dfd.state() != "pending") {
        _this.hollow_mat_dfd = $.Deferred();
      } else {
        $.Topic("materials-update-result").unsubscribe(func);
        $.Topic("materials-update-error").unsubscribe(func);
      }

      $.Topic("materials-update-result").subscribe(func);
      $.Topic("materials-update-error").subscribe(func);
    }

    function on_hollow_success() {
      $("#StaffHollowing #ModifyButton").removeClass("disabled");
      $("#StaffHollowing #ModifyButton").bind(
        "click.vieweroverlay",
        function () {
          $("#StaffHollowing #ModifyButton").addClass("disabled");
          _this.select_screen("hollowing-initial", 1);
          $("#StaffHollowing #ModifyButton").unbind("click.vieweroverlay");
          $("#StaffHollowing #Controls").show("fast");
        }
      );

      $("#StaffHollowing #Controls").hide("fast");
      $("#hollowingToggle .switch, #hollowingToggle2 .switch").removeClass(
        "off"
      );
      $("#hollowingToggle .switch, #hollowingToggle2 .switch").addClass("on");
      $("[data-change-hollowing]").removeClass("hidden");
    }

    function on_hollow_abort() {
      $("#hollowingToggle .switch, #hollowingToggle2 .switch").addClass("off");
      $("#hollowingToggle .switch, #hollowingToggle2 .switch").removeClass(
        "on"
      );
      $("#hollowingToggle, #hollowingToggle2").removeClass("disabled");
      $("#StaffHollowing").hide("fast");
      $("[data-change-hollowing]").addClass("hidden");
    }

    function on_partitioning_success() {
      $("#partitioningToggle .switch").removeClass("off");
      $("#partitioningToggle .switch").addClass("on");
    }

    function on_partitioning_abort() {
      $("#partitioningToggle .switch").addClass("off");
      $("#partitioningToggle .switch").removeClass("on");
      $("#partitioningToggle").removeClass("disabled");
    }

    function enable_print_ui_features(enable) {
      if (enable) {
        $.Topic("enable-review-button").publish("hollowing", true);
        $(".price-widget .quantity").attr("disabled", false);
        $(".price-widget .price-widget-quantity").unbind("click.hollowing");
        $(".summary-widget").unblock();
      } else {
        $.Topic("enable-review-button").publish("hollowing", false);
        $(".price-widget .quantity").attr("disabled", true);
        $(".price-widget .price-widget-quantity").bind(
          "click.hollowing",
          function () {
            Utils.popupMessage(
              "<div class='error'>" +
                gettext(
                  "Quantity change will be available as soon as you finish hollowing."
                ) +
                "</div>"
            );
          }
        );

        $(".summary-widget").block(null);
      }
    }

    function remove_hollowing() {
      var dfd = $.Deferred();

      _this.hollowingui.enableUIComponents(false);
      $("#hollowingToggle, #hollowingToggle2").addClass("disabled");
      $("#print-tabs").block(null);
      _this.hollowingui.abort_ops().then(function () {
        _this.hollowingui.remove_hollowing_and_deinit().then(function () {
          on_hollow_abort();
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);
          hollow_update_price();
          $("#print-tabs").unblock();
          dfd.resolve();
        });
      });

      return dfd.promise();
    }

    this.screens["hollowing-initial"] = {
      can_call_while_active: true,
      /**
       * @param attr Valid values:
       *          0 - Start hollowing
       *          1 - Edit hollowing
       *          2 - Remove hollowing
       *          3 - Restart hollowing
       *          4 - Init only UI components
       */
      enter: function (from, attr) {
        // Add hole button
        if (attr != 2 && from && from.indexOf("hollowing") === 0) {
          _this.hollowingui.start_add_hole();
          $.when(_this.hollow_mat_dfd).then(function () {
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Add a hole")
            );
          });

          return true;
        }

        if (!attr || attr == 1) {
          if (_this.hollowingui) {
            return false;
          }
        }

        function update_warnings() {
          $(".notification-zone .hollowing.hint").hide();
          _this.hollowing_prevent_save = false;
          var warnings = [];

          for (var i = 0; i < _this.hollowingui.design_warnings.length; ++i) {
            warnings.push(_this.hollowingui.design_warnings[i].id);
          }

          $.Topic("set_mesh_warnings").publish(warnings);
          _this.hollowing_prevent_save = _this.hollowingui.have_one_hole > 0;
        }

        function on_add_hole_done() {
          if (!_this.hollowingui) {
            return;
          }

          hollow_update_price();
          update_warnings();

          if (_this.hollowingui.holeCount == 1) {
            _this.select_screen("hollowing-second-hole");
          } else if (!_this.hollowing_prevent_save) {
            _this.select_screen("hollowing-done");
          } else {
            _this.select_screen("hollowing-second-hole");
            $.when(_this.hollow_mat_dfd).then(function () {
              $.Topic("set-viewer-toolbar-message").publish(
                gettext("Add another hole")
              );
            });
          }
        }

        function on_add_hole(design) {
          if (!_this.hollowingui) {
            return;
          }

          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Adding hole...")
          );
          _this.hollowingui.finish_add_hole(design);
        }

        function on_delete_hole() {
          if (!_this.hollowingui) {
            return;
          }

          $.Topic("set-viewer-toolbar-message").publish("");
          hollow_update_price();
          update_warnings();

          if (_this.hollowingui.holeCount == 1) {
            _this.select_screen("hollowing-second-hole");
          } else if (_this.hollowingui.holeCount === 0) {
            _this.select_screen("hollowing-initial");
          } else if (!_this.hollowing_prevent_save) {
            _this.select_screen("hollowing-done");
          } else {
            _this.select_screen("hollowing-second-hole");
            $.when(_this.hollow_mat_dfd).then(function () {
              $.Topic("set-viewer-toolbar-message").publish(
                gettext("Add another hole")
              );
            });
          }
        }

        function on_deinit() {
          $(
            ".notification-zone .hollowing.hint, .notification-zone .hollowing.warning"
          ).hide();
          $.Topic("set_mesh_warnings").publish([]);
          _this.hollowingui = null;
          enable_print_ui_features(true);
          _this.ui.hollowing_done_button.unbind("click.vieweroverlay");
          $.Topic("enable_parts_selection").publish(true);
        }

        function on_fatal_error(msg) {
          $.Topic("set_mesh_warnings").publish([msg.id]);
          remove_hollowing().then(function () {
            _this.select_screen();
          });
        }

        if (attr == 2) {
          if (_this.hollowingui) {
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Going back to original")
            );
            Utils.viewerProgressBar();
            $("#hollowingToggle, #hollowingToggle2").addClass("disabled");
            $("#print-tabs").block(null);
            _this.hollowingui.abort_ops().then(function () {
              _this.hollowingui.remove_hollowing_and_deinit().then(function () {
                on_hollow_abort();
                $.Topic("set-viewer-toolbar-message").publish("");
                Utils.viewerProgressBar(0);
                hollow_update_price();
                _this.select_screen();
                $("#print-tabs").unblock();
                $.Topic("geometry_updated").publish();
              });
            });

            return false;
          }
        }

        var opts = {
          hole_update_type: 1,
          thickness_slider: "#StaffHollowing #Controls #Offset .the-slider",
          step_slider: "#StaffHollowing #Controls #Step .the-slider",
          hole_width_slider: "#StaffHollowing #Controls #Width .the-slider",
          hole_depth_slider: "#StaffHollowing #Controls #Depth .the-slider",
          add_hole_button: _this.ui.hollowing_add_hole_button,
          delete_last_hole_button: _this.ui.hollowing_undo_button,
          reset_button: $(".hollowing-reset-button"),
          create_holes_button: _this.ui.hollowing_done_button,
          on_wall_change: hollow_update_price,
          on_add_hole: on_add_hole,
          on_add_hole_done: on_add_hole_done,
          on_update_hole: hollow_update_price,
          on_delete_hole: on_delete_hole,
          on_deinit: on_deinit,
          on_fatal_error: on_fatal_error,

          //                    "hole_height_slider": "#HeightSliderControl .the-slider"
        };

        if (attr == 2) {
          opts["remove_holes"] = true;
        }

        _this.hollowingui = new HollowingUI(
          _this.screenOpts["hollowing-initial"]["hollow_id"],
          _this.screenOpts["hollowing-initial"]["script_id"],
          _this.screenOpts["hollowing-initial"]["text_id"],
          _this.screenOpts["hollowing-initial"]["hollow_script"],
          _this.screenOpts["hollowing-initial"]["scale_limit"]
        );

        if (attr == 4) {
          opts["init_only_ui"] = true;
          _this.hollowingui.initUI(_this.viewerUI.viewer, _this.design, opts);
          var hollow_op = PrintUtils.design_get_hollowing(_this.design);

          if (hollow_op) {
            if (hollow_op.data.enabled) {
              $.Topic("hollowing-status-update").publish(true);
            } else {
              if (
                !_this.design.material.hole_threshold ||
                !_this.design.material.wall_thickness
              ) {
                $.Topic("hollowing-status-update").publish(
                  false,
                  "hollowing_disabled"
                );
              } else {
                $.Topic("hollowing-status-update").publish(
                  false,
                  "hollowing_design_too_small"
                );
              }
            }
          }

          on_hollow_success();

          return false;
        }

        switch (attr) {
          case 0:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Hollowing your model (this could take a minute)")
            );
            break;
          case 1:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Loading hollowed model")
            );
            break;
          case 2:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Going back to original")
            );
            $("#print-tabs").block(null);
            break;
          case 3:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Loading hollowed model")
            );
            break;
          case 4:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Loading hollowed model")
            );
            break;
        }

        Utils.viewerProgressBar();
        $.Topic("enable_parts_selection").publish(false);

        _this.hollowingui
          .initUI(_this.viewerUI.viewer, _this.design, opts)
          .then(function () {
            if (!_this.hollowingui) {
              return false;
            }

            if (attr == 3 && _this.hollowingui.holeCount > 0) {
              $.Topic("set-viewer-toolbar-message").publish(
                gettext("Removing holes")
              );
              _this.hollowingui.remove_all_holes();
            }

            if (!attr || attr == 1 || attr == 3) {
              $("#StaffHollowing #ModifyButton").addClass("disabled");
              $("#StaffHollowing").show("fast");
              $("#StaffHollowing #Controls").show("fast");
              _this.ui.hollowing_done_button.bind(
                "click.vieweroverlay",
                function () {
                  if (this.disabled) {
                    return false;
                  }

                  _this.select_screen();
                }
              );

              Utils.viewerProgressBar(0);
              update_warnings();

              if (_this.hollowingui.holeCount === 0) {
                _this.hollowingui.start_add_hole();
                $.Topic("set-viewer-toolbar-message").publish(
                  gettext("Done! Click to add holes")
                );
              } else if (_this.hollowing_prevent_save) {
                _this.select_screen("hollowing-second-hole");
              } else {
                _this.select_screen("hollowing-done");
              }
            } else {
              _this.hollowingui.deinitUI();
              on_hollow_abort();
              $.Topic("set-viewer-toolbar-message").publish("");
              Utils.viewerProgressBar(0);
              hollow_update_price();
              $("#print-tabs").unblock();
              $.Topic("geometry_updated").publish();
            }
          });

        enable_print_ui_features(false);

        return attr != 2;
      },

      leave: function (to) {
        if (_this.hollowingui && _this.hollowingui.no_leave) {
          return false;
        }

        if (to && to.indexOf("hollowing") == 0) {
          return true;
        }

        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Going back to original")
        );
        Utils.viewerProgressBar();

        if (_this.hollowingui) {
          _this.hollowingui.no_leave = true;
          remove_hollowing().then(function () {
            _this.select_screen(to);
          });

          return false;
        } else {
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);

          return true;
        }
      },
    };

    this.screens["hollowing-second-hole"] = {
      can_call_while_active: true,
      enter: function (from) {
        _this.ui.root.appendChild(_this.ui.hollowing_undo_button);
        _this.hollowingui.start_add_hole();
        $.when(_this.hollow_mat_dfd).then(function () {
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Add the second hole")
          );
        });
      },

      leave: function (to) {
        if (_this.hollowingui && _this.hollowingui.no_leave) {
          return false;
        }

        _this.ui.hollowing_undo_button.detach();

        if (to && to.indexOf("hollowing") == 0) {
          return true;
        }

        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Going back to original")
        );
        Utils.viewerProgressBar();

        if (_this.hollowingui) {
          _this.hollowingui.no_leave = true;
          remove_hollowing().then(function () {
            _this.select_screen(to);
          });

          return false;
        } else {
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);

          return true;
        }
      },
    };

    this.screens["hollowing-done"] = {
      enter: function (from) {
        _this.ui.root.appendChild(_this.ui.hollowing_done_button);
        _this.ui.root.appendChild(_this.ui.hollowing_add_hole_button);
        _this.ui.root.appendChild(_this.ui.hollowing_undo_button);
        enable_print_ui_features(true);
        $.when(_this.hollow_mat_dfd).then(function () {
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Add more holes or finish up")
          );
        });
      },

      leave: function (to) {
        if (_this.hollowingui && _this.hollowingui.no_leave) {
          return false;
        }

        _this.ui.hollowing_done_button.detach();
        _this.ui.hollowing_add_hole_button.detach();
        _this.ui.hollowing_undo_button.detach();

        if (to && to.indexOf("hollowing") == 0) {
          enable_print_ui_features(false);
          $.Topic("geometry_updated").publish();

          return true;
        }

        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Updating model")
        );
        Utils.viewerProgressBar();

        if (_this.hollowingui) {
          _this.hollowingui.no_leave = true;
          _this.hollowingui.enableUIComponents(false);
          $("#print-tabs").block(null);
          _this.hollowingui.create_holes().then(function () {
            _this.hollowingui.deinitUI();
            on_hollow_success();
            $.Topic("set-viewer-toolbar-message").publish("");
            Utils.viewerProgressBar(0);

            if (_this.updating_material) {
              hollow_update_price();
            }

            $("#print-tabs").unblock();
            _this.select_screen(to);
          });

          return false;
        } else {
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);

          return true;
        }
      },
    };

    this.screens["partitioning-initial"] = {
      can_call_while_active: true,
      /**
       * @param attr Valid values:
       *          0 - Start partitioning
       *          1 - Edit partitioning
       *          2 - Remove partitioning
       *          3 - Restart partitioning
       *          4 - Init only UI components
       */
      enter: function (from, attr) {
        // Add hole button
        if (attr != 2 && from && from.indexOf("partitioning") == 0) {
          _this.partitioningui.start_add_cut();
          $.when(_this.hollow_mat_dfd).then(function () {
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Place the cutting plane")
            );
          });

          return true;
        }

        if ((!attr || attr == 1) && _this.partitioningui) {
          return false;
        }

        if (!attr) {
          _this.ui.root.appendChild(_this.ui.partitioning_split_button);
        }

        function on_add_cut_done() {
          if (!_this.partitioningui) {
            return;
          }

          hollow_update_price();
          _this.select_screen("partitioning-confirm");

          $.when(_this.hollow_mat_dfd).then(function () {
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Confirm cut")
            );
          });
        }

        function on_add_cut(node, transform) {
          if (!_this.partitioningui) {
            return;
          }

          $.Topic("set-viewer-toolbar-message").publish(gettext("Cutting..."));
          _this.partitioningui.finish_add_cut(node, transform);
        }

        function on_deinit() {
          _this.partitioningui = null;
          enable_print_ui_features(true);
          _this.ui.partitioning_done_button.unbind("click.vieweroverlay");
        }

        function on_select_part() {
          _this.ui.root.appendChild(_this.ui.partitioning_delete_part_button);
        }

        function on_delete_part() {
          _this.ui.partitioning_delete_part_button.detach();
          _this.ui.root.appendChild(_this.ui.partitioning_undo_button);
        }

        function on_undo_empty() {
          _this.ui.partitioning_undo_button.detach();
        }

        var opts = {
          split_button: _this.ui.partitioning_split_button,
          add_cut_button: _this.ui.partitioning_add_cut_button,
          delete_part_button: _this.ui.partitioning_delete_part_button,
          undo_button: _this.ui.partitioning_undo_button,
          reset_button: $(".partitioning-reset-button"),
          create_holes_button: _this.ui.partitioning_done_button,
          on_add_cut: on_add_cut,
          on_add_cut_done: on_add_cut_done,
          on_deinit: on_deinit,
          on_select_part: on_select_part,
          on_delete_part: on_delete_part,
          on_undo_empty: on_undo_empty,
        };

        _this.partitioningui = new PartitioningUI(
          _this.screenOpts["partitioning-initial"]["content_types"]
        );

        switch (attr) {
          case 0:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Partitioning mode")
            );
            break;
          case 1:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Loading partitioned model")
            );
            break;
          case 2:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Going back to original")
            );
            $("#print-tabs").block(null);
            break;
          case 3:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Loading partitioned model")
            );
            break;
          case 4:
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Loading partitioned model")
            );
            break;
        }

        Utils.viewerProgressBar();

        _this.partitioningui
          .initUI(_this.viewerUI.viewer, _this.design, opts)
          .then(function () {
            if (!_this.partitioningui) {
              return false;
            }

            if (attr == 3 && _this.partitioningui.holeCount > 0) {
              $.Topic("set-viewer-toolbar-message").publish(
                gettext("Removing cuts")
              );
              _this.partitioningui.remove_all_cuts();
            }

            if (!attr || attr == 1 || attr == 3) {
              _this.ui.partitioning_done_button.bind(
                "click.vieweroverlay",
                function () {
                  if (this.disabled) {
                    return false;
                  }

                  _this.select_screen();
                }
              );

              Utils.viewerProgressBar(0);
              _this.partitioningui.start_add_cut();
            } else {
              // Leave
              _this.partitioningui.abort_ops().then(function () {
                _this.partitioningui
                  .remove_partitioning_and_deinit()
                  .then(function () {
                    on_partitioning_abort();
                    $.Topic("set-viewer-toolbar-message").publish("");
                    Utils.viewerProgressBar(0);
                    hollow_update_price();
                    _this.select_screen();
                    $("#print-tabs").unblock();
                  });
              });
            }
          });

        enable_print_ui_features(false);

        if (attr == 2 && _this.partitioningui) {
          // Leave
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Going back to original")
          );
          Utils.viewerProgressBar();
          $("#partitioningToggle").addClass("disabled");
          $("#print-tabs").block(null);
          _this.partitioningui.abort_ops().then(function () {
            _this.partitioningui
              .remove_partitioning_and_deinit()
              .then(function () {
                on_partitioning_abort();
                $.Topic("set-viewer-toolbar-message").publish("");
                Utils.viewerProgressBar(0);
                hollow_update_price();
                _this.select_screen();
                $("#print-tabs").unblock();
              });
          });

          return false;
        }

        return attr != 2;
      },

      leave: function (to) {
        _this.ui.partitioning_split_button.detach();

        if (_this.partitioningui && _this.partitioningui.no_leave) {
          return false;
        }

        if (to && to.indexOf("partitioning") == 0) {
          return true;
        }

        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Going back to original")
        );
        Utils.viewerProgressBar();

        if (_this.partitioningui) {
          _this.partitioningui.no_leave = true;
          remove_partitioning().then(function () {
            _this.select_screen(to);
          });

          return false;
        } else {
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);

          return true;
        }
      },
    };

    this.screens["partitioning-confirm"] = {
      enter: function (from) {
        _this.ui.root.appendChild(_this.ui.partitioning_done_button);
        _this.ui.root.appendChild(_this.ui.partitioning_add_cut_button);
        enable_print_ui_features(true);
        $.when(_this.hollow_mat_dfd).then(function () {
          $.Topic("set-viewer-toolbar-message").publish(
            gettext("Confirm partitioning")
          );
        });
      },

      leave: function (to) {
        if (_this.partitioningui && _this.partitioningui.no_leave) {
          return false;
        }

        _this.ui.partitioning_done_button.detach();
        _this.ui.partitioning_delete_part_button.detach();
        _this.ui.partitioning_add_cut_button.detach();
        _this.ui.partitioning_undo_button.detach();

        if (to && to.indexOf("partitioning") == 0) {
          enable_print_ui_features(false);

          return true;
        }

        $.Topic("set-viewer-toolbar-message").publish(
          gettext("Updating model")
        );
        Utils.viewerProgressBar();

        if (_this.partitioningui) {
          _this.partitioningui.no_leave = true;
          _this.partitioningui.enableUIComponents(false);
          $("#print-tabs").block(null);
          _this.partitioningui.create_cuts().then(function () {
            _this.partitioningui.deinitUI();
            on_partitioning_success();
            $.Topic("set-viewer-toolbar-message").publish("");
            Utils.viewerProgressBar(0);

            if (_this.updating_material) {
              hollow_update_price();
            }

            $("#print-tabs").unblock();
            _this.select_screen(to);
          });

          return false;
        } else {
          $.Topic("set-viewer-toolbar-message").publish("");
          Utils.viewerProgressBar(0);

          return true;
        }
      },
    };

    this.screens["select_thicken"] = {
      enter: function () {
        _this.ui.root.appendChild(_this.ui.thicken_surface_ui_layer);
        this.design_map = {};
        var design_map = this.design_map;
        var design = _this.viewerUI.design;
        var prttng = design.partitioning;

        if (prttng) {
          var parts = prttng.parts;

          parts.forEach(function (part) {
            design_map[part.design_uuid] = {
              faces: [],
              opid: undefined,
              part: part,
            };
          });
        } else {
          design_map[design.design_uuid] = {
            faces: [],
            opid: undefined,
            part: design,
          };
        }

        for (var t in this.topics) {
          $.Topic(t).subscribe(this.topics[t]);
        }

        _this.viewerUI.toggle_get_face_index(true, function (face, part_) {
          design_map[part_.design_uuid].faces.push(face);
        });
        var thkn_srfce = this;

        this.type = 1;
        this.runOnClick = function () {
          thkn_srfce.update();
        };

        _this.ui.thicken_surface_ui_layer.btn.addEventListener(
          "click",
          this.runOnClick
        );
      },

      run: function (type, sensibility) {
        var thkid = _this.screenOpts.thicken.thicken_surface_id;
        var dfds = [];

        for (var uuid in this.design_map) {
          var part = this.design_map[uuid].part;
          var opid = this.design_map[uuid].opid;
          var material = part.material;
          var solidity = 2.0 * material.get_solidity_threshold(part.size);

          if (!opid) {
            opid = "";
          }

          var res = part.modify_operation(
            opid,
            {
              thickness: solidity,
              sensibility: sensibility,
              id: thkid,
              seed_faces: this.design_map[uuid].faces.toString(),
            },
            type
          );
          var design_map = this.design_map;

          res.done(function (op) {
            if (!op || !op.design) {
              return;
            }

            design_map[op.design.design_uuid].opid = op.id;
          });

          dfds.push(res);
        }

        $.when.apply(null, dfds).then(function () {
          _this.viewerUI.refreshModel();
          printUI.update_materials();
        });
      },

      leave: function () {
        _this.ui.thicken_surface_ui_layer.detach();
        _this.ui.thicken_surface_ui_layer.btn.removeEventListener(
          "click",
          this.runOnClick
        );
        _this.viewerUI.toggle_get_face_index(false);
        this.run(2);

        for (var t in this.topics) {
          $.Topic(t).unsubscribe(this.topics[t]);
        }
      },

      update: function () {
        var s = 0.9 + _this.ui.thicken_surface_ui_layer.slider.value / 10;

        this.run(this.type, parseFloat(s));
        this.type = 0;
      },

      topics: {
        "material-selected": function (design, material, finish) {
          var thkn_srfce = _this.screens.select_thicken;

          thkn_srfce.update();
        },

        "scale-changed": function (design, scale) {
          var op = PrintUtils.design_get_hollowing(design);

          if (op != undefined) {
            return;
          }

          var thkn_srfce = _this.screens.select_thicken;

          thkn_srfce.update();
        },

        "unit-changed": function (design, unit) {
          var thkn_srfce = _this.screens.select_thicken;

          thkn_srfce.update();
        },

        "optimization-operation-updated": function (type, b) {
          if (type != "hollowing") {
            return;
          }

          var thkn_srfce = _this.screens.select_thicken;

          thkn_srfce.update();
        },
      },
    };

    this.screens.thicken = {
      new_geometry: function (opid, type) {
        _this.viewerUI.clear_measurement_tags();

        var surface = this.sratio;
        var thkid = _this.screenOpts.thicken.thicken_id;
        var design = _this.viewerUI.design;
        var parts = design.partitioning ? design.partitioning.parts : [design];
        var nodes = [];
        var self = this;

        this.nodes = nodes;
        var dfds = [];
        var dfds2 = [];
        var bbox_dfds = [];

        this.dfds = dfds;
        this.dfds2 = dfds2;
        this.bbox_dfds = bbox_dfds;
        _this.viewerUI.viewer.setLocal(true);

        for (var k = 0; k < parts.length; k++) {
          var part = parts[k];
          var modelNode;
          var idx = k;

          if (part.node) {
            modelNode = part.node;
          } else {
            modelNode = _this.viewerUI.viewer.getNodesByName("model")[0];
          }

          nodes.push(modelNode);
          modelNode._thicken_dfd = $.Deferred();
          modelNode.bbox_dfd = $.Deferred();
          (function (part, modelNode) {
            var bbox_listener = function (minx, miny, minz, maxx, maxy, maxz) {
              var bb_coords = [
                parseFloat(minx),
                parseFloat(miny),
                parseFloat(minz),
                parseFloat(maxx),
                parseFloat(maxy),
                parseFloat(maxz),
              ];

              part.size.x = bb_coords[3] - bb_coords[0];
              part.size.y = bb_coords[4] - bb_coords[1];
              part.size.z = bb_coords[5] - bb_coords[2];
              part.size.bbox = bb_coords;
              this.bbox_dfd.resolve(idx);
              modelNode.removeEventListener("bbox", bbox_listener);
            };

            modelNode.addEventListener("bbox", bbox_listener);

            var load_resolve = function (e) {
              this._thicken_dfd.resolve(e);
              modelNode.removeEventListener("load", load_resolve);
            };

            modelNode.addEventListener("load", load_resolve);

            if (type == 1) {
              var errorMessage_func = function (e) {
                _this.viewerUI.viewer.setLocal(false);
                this._thicken_dfd.reject();
                this.bbox_dfd.reject();
                modelNode.removeEventListener(
                  "errorMessage",
                  errorMessage_func
                );
              };

              modelNode.addEventListener("errorMessage", errorMessage_func);
            }
          })(part, modelNode);

          dfds.push(modelNode._thicken_dfd);
          bbox_dfds.push(modelNode.bbox_dfd);

          // Accounting for thickening precision
          var solidity = 1.45 * part.material.get_solidity_threshold(part.size);

          dfds2.push(
            part.modify_operation(
              opid ? opid[k] : "",
              {
                surface: surface,
                thickness: solidity,
                id: thkid,
              },
              type
            )
          );
        }

        $.when
          .apply(null, dfds)
          .then(function () {
            Utils.viewerProgressBar(0);
            $.Topic("optimization-operation-updated").publish(1, true);
            $.Topic("set-viewer-toolbar-message").publish(undefined);

            var render_after_price = function () {
              _this.viewerUI.viewer.setLocal(false);
              $.Topic("materials-update-result").unsubscribe(
                render_after_price
              );
              $.Topic("materials-update-error").unsubscribe(render_after_price);
            };

            _this.ui.thk_min.cleanUp();
            $.Topic("materials-update-result").subscribe(render_after_price);
            $.Topic("materials-update-error").subscribe(render_after_price);
            printUI.update_materials();
            $.Topic("geometry_updated").publish();
          })
          .fail(function () {
            _this.viewerUI.viewer.setLocal(false);
            _this.screens.thicken.leave();
            $.Topic("set-viewer-toolbar-message").publish(
              gettext("Thickening failed reverting your model")
            );
            $(
              "#thickeningToggle .switch, #thickeningToggle2 .switch"
            ).toggleClass("off");
            _this.viewerUI.on_viewer_error(
              gettext(
                "The operation could not succeed because of the complexity of the model"
              )
            );
          });

        $.when.apply(null, bbox_dfds).then(function () {
          if (parts.length == 1) {
            var part = parts[0];
            var i;
            var fields = $(".scale-field");

            for (i = 0; i < 3; i++) {
              fields[i].value = Math.round(
                part.size[fields[i].name] * part.size.userScale
              );
            }
          } else {
            var repack = design.get_operation("RepackGroupsDesignOperation");
            var packing = repack.data._packing.split(",");
            var i;
            var minx, miny, minz, maxx, maxy, maxz;

            minx = Number.POSITIVE_INFINITY;
            miny = Number.POSITIVE_INFINITY;
            minz = Number.POSITIVE_INFINITY;
            maxx = Number.NEGATIVE_INFINITY;
            maxy = Number.NEGATIVE_INFINITY;
            maxz = Number.NEGATIVE_INFINITY;

            for (i = 0; i < parts.length; i++) {
              var idx = parseInt(packing[i * 4]);
              var bbox = parts[idx].size.bbox;
              var part_scale = parseFloat(parts[idx].size.userScale);
              var tbbox = [
                (bbox[0] + parseFloat(packing[4 * i + 1])) * part_scale,
                (bbox[1] + parseFloat(packing[4 * i + 2])) * part_scale,
                (bbox[2] + parseFloat(packing[4 * i + 3])) * part_scale,
                (bbox[3] + parseFloat(packing[4 * i + 1])) * part_scale,
                (bbox[4] + parseFloat(packing[4 * i + 2])) * part_scale,
                (bbox[5] + parseFloat(packing[4 * i + 3])) * part_scale,
              ];

              if (tbbox[0] < minx) {
                minx = tbbox[0];
              }

              if (tbbox[1] < miny) {
                miny = tbbox[1];
              }

              if (tbbox[2] < minz) {
                minz = tbbox[2];
              }

              if (tbbox[3] > maxx) {
                maxx = tbbox[3];
              }

              if (tbbox[4] > maxy) {
                maxy = tbbox[4];
              }

              if (tbbox[5] > maxz) {
                maxz = tbbox[5];
              }
            }

            var size = { x: maxx - minx, y: maxy - miny, z: maxz - minz };
            var fields = $(".scale-field");

            for (i = 0; i < 3; i++) {
              fields[i].value = Math.round(size[fields[i].name]);
            }
          }
        });

        Utils.viewerProgressBar();
        $.when
          .apply(null, dfds2)
          .done(function (data) {
            if (type == 0 || type == 1) {
              $.Topic("set-viewer-toolbar-message").publish(
                gettext("Thickening your model (this could take a minute)")
              );
            }

            _this.viewerUI.refreshModel();
          })
          .fail(function () {
            _this.viewerUI.viewer.setLocal(false);
          });
      },

      update_geometry: function (type) {
        var op_ids = [];
        var design = _this.viewerUI.design;
        var parts = design.partitioning ? design.partitioning.parts : [design];

        for (var k = 0; k < parts.length; k++) {
          var part = parts[k];
          var op = part.get_operation("ThickenAreasDesignOperation");

          if (!op) {
            return;
          }

          op_ids.push(op.id);
        }

        this.new_geometry(op_ids, type);
      },

      enter: function (from, attr) {
        _this.viewerUI.no_minima = true;
        this.sratio = 0.001;

        this.new_geometry(undefined, 1);

        for (var t in this.topics) {
          $.Topic(t).subscribe(this.topics[t]);
        }
      },

      leave: function (to) {
        _this.viewerUI.no_minima = false;

        if (this.nodes && this.nodes.length) {
          for (var k = 0; k < this.nodes.length; k++) {
            if (this.nodes[k].listeners.load.length) {
              this.nodes[k].removeEventListener(
                "load",
                this.nodes[k].listeners.load[0]
              );
            }

            if (this.nodes[k].listeners.errorMessage.length) {
              this.nodes[k].removeEventListener(
                "errorMessage",
                this.nodes[k].listeners.errorMessage[0]
              );
            }
          }
        }

        this.update_geometry(2);

        for (var t in this.topics) {
          $.Topic(t).unsubscribe(this.topics[t]);
        }
      },

      topics: {
        "material-selected": function (design, material, finish) {
          _this.screens.thicken.update_geometry(0);
        },

        "scale-changed": function (design, scale) {
          var op = PrintUtils.design_get_hollowing(design);

          if (op != undefined) {
            return;
          }

          _this.screens.thicken.update_geometry(0);
        },

        "unit-changed": function (design, unit) {
          _this.screens.thicken.update_geometry(0);
        },

        "optimization-operation-updated": function (type, b) {
          if (type != "hollowing") {
            return;
          }

          _this.screens.thicken.update_geometry(0);
        },
      },
    };

    this.screens.review = {
      get_pt_list: function (data) {
        _this.ui.thk_min.cleanUp();
        _this.ui.thk_min.update(
          data,
          _this.ui.root,
          function (coord, normal, a, event_type, name) {
            var center = _this.viewerUI.design.center;
            var rotq;

            if (normal) {
              rotq = new CameraRotation(normal);
            } else {
              rotq = new CameraRotation([
                -coord.x + center.x,
                -coord.y + center.y,
                -coord.z + center.z,
              ]);
            }

            rotq = rotq.buildRotationFrom(CameraRotation.Y_AXIS);
            var p = [coord.x, coord.y, coord.z, 1];

            a.addEventListener(event_type, function (event) {
              if (_this.viewerUI.solidity_animation) {
                _this.viewerUI.solidity_animation.cancel();
              }

              if (this.activated) {
                this.deactivate();
              } else {
                this.activate();
                _this.viewerUI.solidity_animation =
                  _this.viewerUI.viewer.animateCamera(
                    undefined,
                    [0, 0],
                    1.0,
                    800,
                    undefined,
                    function () {
                      _this.viewerUI.solidity_animation =
                        _this.viewerUI.viewer.animateCamera(
                          rotq,
                          undefined,
                          1.0,
                          1400,
                          undefined,
                          function () {
                            _this.viewerUI.solidity_animation =
                              _this.viewerUI.viewer.animateCamera(
                                undefined,
                                undefined,
                                0.5,
                                800
                              );
                          }
                        );
                    }
                  );
              }
            });
          }
        );
      },

      topics: {
        "material-selected": function (design, material, finish) {
          $.Topic("arrange_parts").publish();
          _this.viewerUI.update_solidity_thresholds();
          this.req = _this.viewerUI.get_local_thickness_minima(
            _this.screens.review.get_pt_list
          );
        },

        "scale-changed": function (design, scale) {
          $.Topic("arrange_parts").publish();
          _this.viewerUI.update_solidity_thresholds();
          var op = PrintUtils.design_get_hollowing(design);

          if (op != undefined) {
            return;
          }

          this.req = _this.viewerUI.get_local_thickness_minima(
            _this.screens.review.get_pt_list
          );
        },

        "unit-changed": function (design, unit) {
          $.Topic("arrange_parts").publish();
          _this.viewerUI.update_solidity_thresholds();
          this.req = _this.viewerUI.get_local_thickness_minima(
            _this.screens.review.get_pt_list
          );
        },

        "materials-update-result": function () {
          $.Topic("arrange_parts").publish();
          _this.viewerUI.update_solidity_thresholds();
        },

        "optimization-operation-updated": function (type, b) {
          if (type != 1) {
            return;
          }

          $.Topic("arrange_parts").publish();
          _this.viewerUI.update_solidity_thresholds();
          this.req = _this.viewerUI.get_local_thickness_minima(
            _this.screens.review.get_pt_list
          );
        },
      },

      annotationOff: null,

      set_annotations: function (enabled, soft) {
        if (enabled) {
          if (!soft) {
            _this.screens.review.get_pt_list = function () {};
            console.log(this.req);
            this.req.forEach(function (dfd) {
              dfd.reject();
            });
            _this.ui.solidity_check_panel.detach();
            _this.ui.thk_min.detach();
            _this.viewerUI.viewer.unbind(
              "click",
              _this.viewerUI.bound_solidity_check_tag_onclick
            );
            //_this.viewerUI.toggle_display_grid(false);
          }
          this.annotationOff = AnnotationModule.setUp();
        } else if (this.annotationOff) {
          var that = this;
          this.annotationOff(function () {
            that.annotationOff = null;
            if (!soft) {
              _this.screens.review.get_pt_list = _this.old_get_pt_list;
              _this.ui.root.appendChild(_this.ui.solidity_check_panel);
              //_this.viewerUI.toggle_display_grid(true);
              this.req = _this.viewerUI.get_local_thickness_minima(
                _this.screens.review.get_pt_list
              );
              _this.viewerUI.viewer.bind(
                "click",
                _this.viewerUI.bound_solidity_check_tag_onclick
              );
            }
          });
        }
      },

      enter: function (from) {
        $.Topic("enable_parts_selection").publish(false);
        if (_this.design.manufacturing_type == 1) {
          _this.ui.root.appendChild(_this.ui.solidity_check_panel);
          _this.viewerUI.toggle_solidity_check(true);
          _this.viewerUI.toggle_display_grid(true);
          _this.old_get_pt_list = _this.screens.review.get_pt_list;
          this.req = _this.viewerUI.get_local_thickness_minima(
            _this.screens.review.get_pt_list
          );
        }
      },

      _leave: function (to) {
        if (_this.design.manufacturing_type == 1) {
          _this.screens.review.get_pt_list = _this.old_get_pt_list;
          _this.ui.solidity_check_panel.detach();
          _this.ui.thk_min.detach();
          _this.viewerUI.toggle_solidity_check(false);
          _this.viewerUI.toggle_display_grid(false);
        }

        if (this.req) {
          this.req.forEach(function (dfd) {
            dfd.reject();
          });
        }

        $.Topic("enable_parts_selection").publish(true);
      },

      leave: function (to) {
        if (_this.design.manufacturing_type == 1 && to != "cutaway") {
          this.set_annotations(false, true);
        }
        this._leave(to);
      },
    };

    this.screens.cutaway = {
      enter: function (from) {
        _this.viewerUI.toggle_display_grid(true);
        _this.ui.root.appendChild(_this.ui.cut_axis);
        _this.ui.root.appendChild(_this.ui.cut_slider);

        if (_this.viewerUI.cut.axis == "X") {
          _this.ui.cut_axis_X.setOpacity(1.0);
        } else if (_this.viewerUI.cut.axis == "Y") {
          _this.ui.cut_axis_Y.setOpacity(1.0);
        } else {
          _this.ui.cut_axis_Z.setOpacity(1.0);
        }
      },

      leave: function (to) {
        _this.viewerUI.toggle_display_grid(false);
        _this.ui.cut_axis.detach();
        _this.ui.cut_slider.detach();
        _this.viewerUI.viewer_update({ cutAxis: null });
      },
    };
  },

  setupUI: function (viewer, bottom_offset, top_offset) {
    var _this = this;
    var parser = new Sculpteo3DViewerUIParser(viewer);

    parser.loadFromDOMElementById("viewer-ui");

    var root = viewer.getRootLayer();

    this.ui = {};
    this.ui.root = root;

    bottom_offset = bottom_offset || 0;
    top_offset = top_offset || 0;

    var left = root.frame.x;
    var top = root.frame.y + top_offset;
    var width = root.frame.w;
    var height = root.frame.h - bottom_offset;

    var local_thickness_minima_panel = parser.getElementById(
      "local_thickness_minima_panel"
    );
    var local_thickness_minima_description = parser.getElementById(
      "local_thickness_minima_description"
    );

    this.ui.thk_min = new Sculpteo3DViewerUIThkMinOverlay(
      local_thickness_minima_panel,
      _this.viewerUI,
      local_thickness_minima_description,
      top + 10,
      width - 115,
      25
    );

    // Solidity check legend
    this.ui.solidity_check_panel = parser.getElementById(
      "solidity-check-panel"
    );
    this.ui.solidity_check_gradient = parser.getElementById(
      "solidity-check-gradient"
    );
    this.ui.solidity_check_panel.setFrame(
      width - 20 - 160,
      height - 44,
      175,
      50
    );
    this.ui.solidity_check_gradient.setFrame(5, 20, 160, 10);

    var panelImage = viewer.createImage(STATIC_URL + "css/images/legendeH.png");

    this.ui.solidity_check_gradient.setBackgroundImage(panelImage, 0, 0);
    this.ui.solidity_check_panel.appendChild(this.ui.solidity_check_gradient);

    /*Shadow*/
    this.ui.solidity_check_label_low_shadow = parser.getElementById(
      "solidity-check-low-shadow"
    );
    this.ui.solidity_check_label_high_shadow = parser.getElementById(
      "solidity-check-high-shadow"
    );
    this.ui.solidity_check_label_low_shadow.setFrame(0, 1);
    this.ui.solidity_check_label_high_shadow.setFrame(
      this.ui.solidity_check_panel.frame.w -
        this.ui.solidity_check_label_high_shadow.frame.w +
        1,
      1
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_low_shadow
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_high_shadow
    );

    this.ui.solidity_check_label_low_shadow2 = parser.getElementById(
      "solidity-check-low-shadow2"
    );
    this.ui.solidity_check_label_high_shadow2 = parser.getElementById(
      "solidity-check-high-shadow2"
    );
    this.ui.solidity_check_label_low_shadow2.setFrame(-1, 0);
    this.ui.solidity_check_label_high_shadow2.setFrame(
      this.ui.solidity_check_panel.frame.w -
        this.ui.solidity_check_label_high_shadow2.frame.w +
        3,
      0
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_low_shadow2
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_high_shadow2
    );

    this.ui.solidity_check_label_low_shadow3 = parser.getElementById(
      "solidity-check-low-shadow3"
    );
    this.ui.solidity_check_label_high_shadow3 = parser.getElementById(
      "solidity-check-high-shadow3"
    );
    this.ui.solidity_check_label_low_shadow3.setFrame(0, -1);
    this.ui.solidity_check_label_high_shadow3.setFrame(
      this.ui.solidity_check_panel.frame.w -
        this.ui.solidity_check_label_high_shadow3.frame.w +
        1,
      -1
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_low_shadow3
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_high_shadow3
    );

    this.ui.solidity_check_label_low_shadow4 = parser.getElementById(
      "solidity-check-low-shadow4"
    );
    this.ui.solidity_check_label_high_shadow4 = parser.getElementById(
      "solidity-check-high-shadow4"
    );
    this.ui.solidity_check_label_low_shadow4.setFrame(1, 0);
    this.ui.solidity_check_label_high_shadow4.setFrame(
      this.ui.solidity_check_panel.frame.w -
        this.ui.solidity_check_label_high_shadow4.frame.w +
        2,
      0
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_low_shadow4
    );
    this.ui.solidity_check_panel.appendChild(
      this.ui.solidity_check_label_high_shadow4
    );

    this.ui.solidity_check_label_low =
      parser.getElementById("solidity-check-low");
    this.ui.solidity_check_label_high = parser.getElementById(
      "solidity-check-high"
    );
    this.ui.solidity_check_label_low.setFrame(0, 0);
    this.ui.solidity_check_label_high.setFrame(
      this.ui.solidity_check_panel.frame.w -
        this.ui.solidity_check_label_high.frame.w +
        2,
      0
    );
    this.ui.solidity_check_panel.appendChild(this.ui.solidity_check_label_low);
    this.ui.solidity_check_panel.appendChild(this.ui.solidity_check_label_high);

    this.ui.thicken_surface_ui_layer = parser.getElementById(
      "thicken_surface_panel"
    );
    this.ui.thicken_surface_ui_layer.slider = parser.getElementById(
      "thicken_surface_slider"
    );
    this.ui.thicken_surface_ui_layer.btn = parser.getElementById(
      "thicken_surface_panel_run"
    );
    this.ui.thicken_surface_ui_layer.btn.setFrame(0, 0);
    this.ui.thicken_surface_ui_layer.slider.setFrame(
      0,
      this.ui.thicken_surface_ui_layer.btn.frame.h + 10,
      100,
      50
    );
    this.ui.thicken_surface_ui_layer.setFrame(
      0,
      200,
      this.ui.thicken_surface_ui_layer.slider.frame.w,
      this.ui.thicken_surface_ui_layer.btn.frame.h +
        this.ui.thicken_surface_ui_layer.slider.frame.h +
        10
    );
    this.ui.thicken_surface_ui_layer.appendChild(
      this.ui.thicken_surface_ui_layer.slider
    );
    this.ui.thicken_surface_ui_layer.appendChild(
      this.ui.thicken_surface_ui_layer.btn
    );

    // Cut-away axis
    this.ui.cut_axis = viewer.createUILayer();
    var cutXImage = viewer.createImage(
      STATIC_URL + "images/special/cutaway/x-axis.png"
    );

    this.ui.cut_axis_X = viewer.createUILayer();
    this.ui.cut_axis_X.setBackgroundImage(cutXImage, 0, 0);
    this.ui.cut_axis_X.setOpacity(0.3);
    this.ui.cut_axis_X.setFrame(50, 50, 50, 30);
    this.ui.cut_axis_X.mouseenter(function (event) {
      _this.ui.cut_axis_X.setOpacity(1.0);
    });

    this.ui.cut_axis_X.mouseleave(function (event) {
      if (_this.viewerUI.cut.axis != "X") {
        _this.ui.cut_axis_X.setOpacity(0.3);
      }
    });

    var cutYImage = viewer.createImage(
      STATIC_URL + "images/special/cutaway/y-axis.png"
    );

    this.ui.cut_axis_Y = viewer.createUILayer();
    this.ui.cut_axis_Y.setBackgroundImage(cutYImage, 0, 0);
    this.ui.cut_axis_Y.setOpacity(0.3);
    this.ui.cut_axis_Y.setFrame(0, 50, 50, 30);
    this.ui.cut_axis_Y.mouseenter(function (event) {
      _this.ui.cut_axis_Y.setOpacity(1.0);
    });

    this.ui.cut_axis_Y.mouseleave(function (event) {
      if (_this.viewerUI.cut.axis != "Y") {
        _this.ui.cut_axis_Y.setOpacity(0.3);
      }
    });

    var cutZImage = viewer.createImage(
      STATIC_URL + "images/special/cutaway/z-axis.png"
    );

    this.ui.cut_axis_Z = viewer.createUILayer();
    this.ui.cut_axis_Z.setBackgroundImage(cutZImage, 0, 0);
    this.ui.cut_axis_Z.setOpacity(0.3);
    this.ui.cut_axis_Z.setFrame(20, 0, 30, 50);
    this.ui.cut_axis_Z.mouseenter(function (event) {
      _this.ui.cut_axis_Z.setOpacity(1.0);
    });

    this.ui.cut_axis_Z.mouseleave(function (event) {
      if (_this.viewerUI.cut.axis != "Z") {
        _this.ui.cut_axis_Z.setOpacity(0.3);
      }
    });

    this.ui.cut_axis_X.click(function (event) {
      _this.viewerUI.cut.axis = "X";
      _this.viewerUI.update_cut();
      _this.ui.cut_axis_X.setOpacity(1.0);
      _this.ui.cut_axis_Y.setOpacity(0.3);
      _this.ui.cut_axis_Z.setOpacity(0.3);
    });

    this.ui.cut_axis_Y.click(function (event) {
      _this.viewerUI.cut.axis = "Y";
      _this.viewerUI.update_cut();
      _this.ui.cut_axis_X.setOpacity(0.3);
      _this.ui.cut_axis_Y.setOpacity(1.0);
      _this.ui.cut_axis_Z.setOpacity(0.3);
    });

    this.ui.cut_axis_Z.click(function (event) {
      _this.viewerUI.cut.axis = "Z";
      _this.viewerUI.update_cut();
      _this.ui.cut_axis_X.setOpacity(0.3);
      _this.ui.cut_axis_Y.setOpacity(0.3);
      _this.ui.cut_axis_Z.setOpacity(1.0);
    });

    this.ui.cut_axis.setFrame(width - 120, height - 130, 100, 80);
    this.ui.cut_axis.appendChild(this.ui.cut_axis_X);
    this.ui.cut_axis.appendChild(this.ui.cut_axis_Y);
    this.ui.cut_axis.appendChild(this.ui.cut_axis_Z);

    this.ui.cut_slider = viewer.createUILayer();
    this.ui.cut_slider.setFrame(width - 200, height - 45, 200, 40);

    /*Shadows*/
    this.ui.cut_height_slider_label_shadow = parser.getElementById(
      "cut-height-slider-label-shadow"
    );
    this.ui.cut_height_slider_label_shadow.setFrame(16, 0);

    this.ui.cut_height_slider_label_shadow2 = parser.getElementById(
      "cut-height-slider-label-shadow2"
    );
    this.ui.cut_height_slider_label_shadow2.setFrame(15, 1);

    this.ui.cut_height_slider_label_shadow3 = parser.getElementById(
      "cut-height-slider-label-shadow3"
    );
    this.ui.cut_height_slider_label_shadow3.setFrame(14, 0);

    this.ui.cut_height_slider_label_shadow4 = parser.getElementById(
      "cut-height-slider-label-shadow4"
    );
    this.ui.cut_height_slider_label_shadow4.setFrame(15, -1);
    /**/

    this.ui.cut_height_slider_label = parser.getElementById(
      "cut-height-slider-label"
    );
    this.ui.cut_height_slider_label.setFrame(15, 0, 150, 16);

    this.ui.cut_height_slider = parser.getElementById("cut-height-slider");
    this.ui.cut_height_slider.sliderFillLayer.backgroundColor = {
      r: 68,
      g: 153,
      b: 238,
      a: 255,
    };
    this.ui.cut_height_slider.sliderFillLayer.borderColor = {
      r: 255,
      g: 255,
      b: 255,
      a: 255,
    };
    this.ui.cut_height_slider.handleStyle.frame = { x: 0, y: 0, w: 30, h: 14 };
    this.ui.cut_height_slider.handleLayer.backgroundColor = {
      r: 170,
      g: 170,
      b: 170,
      a: 255,
    };
    this.ui.cut_height_slider.handleLayer.highlightStyle.backgroundColor = {
      r: 190,
      g: 190,
      b: 190,
      a: 255,
    };
    this.ui.cut_height_slider.setFrame(0, 20, 180, 16);
    this.ui.cut_height_slider.setValue(0.5);
    this.ui.cut_height_slider.addEventListener(["slide", "stop"], function () {
      _this.viewerUI.cut.enabled = true;
      _this.viewerUI.cut.value = this.value;
      _this.viewerUI.update_cut();
    });

    this.ui.cut_slider.appendChild(this.ui.cut_height_slider);
    this.ui.cut_slider.appendChild(this.ui.cut_height_slider_label_shadow);
    this.ui.cut_slider.appendChild(this.ui.cut_height_slider_label_shadow2);
    this.ui.cut_slider.appendChild(this.ui.cut_height_slider_label_shadow3);
    this.ui.cut_slider.appendChild(this.ui.cut_height_slider_label_shadow4);
    this.ui.cut_slider.appendChild(this.ui.cut_height_slider_label);

    // Hollowing buttons
    this.ui.hollowing_undo_button = parser.getElementById("hollowing-undo");
    this.ui.hollowing_undo_button.setFrame(
      left + 15,
      height - this.ui.hollowing_undo_button.frame.h - 7
    );

    this.ui.hollowing_done_button = parser.getElementById("hollowing-done");
    this.ui.hollowing_done_button.setFrame(
      width - this.ui.hollowing_done_button.frame.w - 15,
      height - this.ui.hollowing_done_button.frame.h - 7
    );

    this.ui.hollowing_add_hole_button =
      parser.getElementById("hollowing-add-hole");
    this.ui.hollowing_add_hole_button.setFrame(
      width -
        this.ui.hollowing_add_hole_button.frame.w -
        15 -
        this.ui.hollowing_done_button.frame.w -
        15,
      height - this.ui.hollowing_add_hole_button.frame.h - 7
    );

    // Partitioning buttons
    this.ui.partitioning_undo_button =
      parser.getElementById("partitioning-undo");
    this.ui.partitioning_undo_button.setFrame(
      left + 15,
      height - this.ui.partitioning_undo_button.frame.h - 7
    );
    this.ui.partitioning_done_button =
      parser.getElementById("partitioning-done");
    this.ui.partitioning_done_button.setFrame(
      width - this.ui.partitioning_done_button.frame.w - 15,
      height - this.ui.partitioning_done_button.frame.h - 7
    );

    this.ui.partitioning_add_cut_button = parser.getElementById(
      "partitioning-add-cut"
    );
    this.ui.partitioning_add_cut_button.setFrame(
      width -
        this.ui.partitioning_add_cut_button.frame.w -
        15 -
        this.ui.partitioning_done_button.frame.w -
        15,
      height - this.ui.partitioning_add_cut_button.frame.h - 7
    );

    this.ui.partitioning_delete_part_button = parser.getElementById(
      "partitioning-delete-part"
    );
    this.ui.partitioning_delete_part_button.setFrame(
      width -
        this.ui.partitioning_delete_part_button.frame.w -
        15 -
        this.ui.partitioning_add_cut_button.frame.w -
        15 -
        this.ui.partitioning_done_button.frame.w -
        15,
      height - this.ui.partitioning_delete_part_button.frame.h - 7
    );

    this.ui.partitioning_split_button =
      parser.getElementById("partitioning-split");
    this.ui.partitioning_split_button.setFrame(
      width - this.ui.partitioning_split_button.frame.w - 15,
      height - this.ui.partitioning_split_button.frame.h - 7
    );

    this.ui.series_orient_save_button = parser.getElementById(
      "series-orient-save-button"
    );
    this.ui.series_orient_save_button.setFrame(
      root.frame.w - this.ui.series_orient_save_button.frame.w - 15,
      height - this.ui.series_orient_save_button.frame.h - 7
    );

    this.ui.series_orient_cancel_button = parser.getElementById(
      "series-orient-cancel-button"
    );
    this.ui.series_orient_cancel_button.setFrame(
      width -
        this.ui.series_orient_cancel_button.frame.w -
        15 -
        this.ui.series_orient_save_button.frame.w -
        10,
      height - this.ui.series_orient_cancel_button.frame.h - 7
    );

    this.ui.series_orient_buttons = $("#series-orient-buttons").detach();

    this.ui.series_cut_slider = parser.getElementById("series-cut-slider");
    this.ui.series_cut_slider.sliderFillLayer.backgroundColor = {
      r: 68,
      g: 153,
      b: 238,
      a: 255,
    };
    this.ui.series_cut_slider.sliderFillLayer.borderColor = {
      r: 255,
      g: 255,
      b: 255,
      a: 255,
    };
    this.ui.series_cut_slider.handleStyle.frame = { x: 0, y: 0, w: 14, h: 30 };
    this.ui.series_cut_slider.handleLayer.backgroundColor = {
      r: 170,
      g: 170,
      b: 170,
      a: 255,
    };
    this.ui.series_cut_slider.handleLayer.highlightStyle.backgroundColor = {
      r: 190,
      g: 190,
      b: 190,
      a: 255,
    };
    this.ui.series_cut_slider.setFrame(width - 50, left + 40, 40, 310);

    this.ui.disable_overlay = viewer.createUILayer();
    this.ui.disable_overlay.setFrame(0, 0, root.frame.w, root.frame.h);
  },

  select_screen: function (screen, attr) {
    var from = this.screen;
    var to = screen;

    if (from == to) {
      if (from && this.screens[from].can_call_while_active) {
        this.screens[from].enter(from, attr);
      }

      return;
    }

    // Leave previous screen
    if (from && this.screens[from]) {
      var can_leave = true;

      if (this.screens[from].leave) {
        can_leave = this.screens[from].leave(to);
      }

      if (can_leave !== undefined && !can_leave) {
        return false;
      }

      if (this.screens[from].topics) {
        for (var t in this.screens[from].topics) {
          $.Topic(t).unsubscribe(this.screens[from].topics[t]);
        }
      }
    }

    $(".screen", this.$container).hide();
    this.screen = null;

    // Enter new screen
    if (to && this.screens[to]) {
      var can_enter = true;

      if (this.screens[to].enter) {
        can_enter = this.screens[to].enter(from, attr);
      }

      if (can_enter !== undefined && !can_enter) {
        return false;
      }

      if (this.screens[to].topics) {
        for (var t in this.screens[to].topics) {
          $.Topic(t).subscribe(this.screens[to].topics[t]);
        }
      }
    }

    if (screen) {
      $(".screen-" + screen, this.$container).show();
    }

    this.screen = screen;

    // Notify
    $.Topic("screen-selected").publish(from, to);

    return true;
  },
};
